/**
 * Block is used on
 *
 * @returns {{buttonPaymentLoading: boolean, completeStepTwo(): (undefined), getErrorText(*=): (string|*), paymentType: string, validateField(*=): (undefined), redirectionButtonVisible: boolean, careHome: string, careHomeNames: [], init(): void, amount: string, productId: number, goToStep(*): void, branchName: string, accountNumber: string, completeStepOne(*): void, minAmountValue: number, buttonOneLoading: boolean, sandboxMode: boolean, success: boolean, homeCareBranches: [], name: string, step: number, maxAmountValue: number, hasError(*): *, buttonTwoLoading: boolean, open: boolean, errors: []}}
 */
export default () => ({
    step: 1,

    // Step 1
    paymentType: '',
    productId: 0,
    buttonOneLoading: false,
    buttonTwoLoading: false,

    // Step 2
    careHome: '',
    branchName: '',
    name: '',
    accountNumber: '',
    amount: '',
    buttonPaymentLoading: false,

    // Buttons
    redirectionButtonVisible: false,

    // Modal
    open: false,

    // Generic
    errors: [],
    success: false,

    // Lists
    careHomeNames: [],
    homeCareBranches: [],

    minAmountValue: 10.50,
    maxAmountValue: 10000,

    sandboxMode: false,

    init() {
        if (this.sandboxMode) {
            this.step = 2;
            this.productId = 377;
            this.paymentType = 'hch';

            this.name = 'John Doe';
            this.amount = 12;
            this.accountNumber = 10000;
        }

        this.careHomeNames = window.careHomeNames;
        this.homeCareBranches = window.homeCareBranches;
    },

    completeStepOne(type) {
        this.buttonOneLoading = false;
        this.buttonTwoLoading = false;

        if (type === 'hch') {
            this.productId = 377;
            this.buttonOneLoading = true;
        }
        else if (type === 'mhc') {
            this.productId = 403;
            this.buttonTwoLoading = true;
        }

        this.paymentType = type;

        setTimeout(() => {
            this.step = 2;
        }, 500)
    },

    completeStepTwo() {
        let ref = this;

        this.errors = [];
        this.buttonPaymentLoading = true;

        this.validateField('careHome');
        this.validateField('name');
        this.validateField('accountNumber');
        this.validateField('amount');

        if (this.errors.length > 0) {
            this.buttonPaymentLoading = false;
            return;
        }

        let name = '';
        if (this.paymentType === 'hch')
            name = this.careHome;
        else if (this.paymentType === 'mhc')
            name = this.branchName;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_submit_payment_form&care_home=' +name +'&name=' + this.name +'&reference=' + this.accountNumber +'&amount=' + this.amount + '&product_id=' + this.productId
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                ref.buttonPaymentLoading = true;
                ref.open = true;

                setTimeout(() => {
                    ref.redirectionButtonVisible = true;
                }, 350)

                setTimeout(() => {
                    window.location = '/checkout/';
                }, 650)
            })
            .catch((error) => {
                console.error(error);
            });
    },

    goToStep(step) {
        this.errors = [];
        this.step = step;
        this.buttonOneLoading = false;
        this.buttonTwoLoading = false;
        this.buttonPaymentLoading = false;
    },

    /**
     * Check if the errors array contains this field.
     *
     * @param field
     * @returns {*}
     */
    hasError(field) {
        return this.errors.find(x => x.field === field);
    },

    /**
     * Fetch the error text for this message.
     *
     * @param field
     * @returns {string|*}
     */
    getErrorText(field) {
        if (this.hasError(field))
            return this.errors.find(x => x.field === field).message;

        return '';
    },

    validateField(field) {
        if (this.paymentType === 'hch') {
            if (field === 'careHome') {
                if (this.careHome.length === 0) {
                    this.errors.push({
                        'field': field,
                        'message': 'Please select an option.'
                    });

                    return;
                }
            }
        }

        if (this.paymentType === 'mhc') {
            if (field === 'branchName') {
                if (this.branchName.length === 0) {
                    this.errors.push({
                        'field': field,
                        'message': 'Please select an option.'
                    });

                    return;
                }
            }
        }

        if (field === 'name') {
            if (this.name.length === 0) {
                this.errors.push({
                    'field': field,
                    'message': 'Please enter the name shown on your invoice.'
                });

                return;
            }
        }

        if (field === 'accountNumber') {
            if (this.accountNumber.length === 0) {
                this.errors.push({
                    'field': field,
                    'message': 'Please enter a value.'
                });

                return;
            }
        }

        if (field === 'amount') {
            if (this.amount.length === 0) {
                this.errors.push({
                    'field': field,
                    'message': 'Please enter a value.'
                });

                return;
            }

            let amount = Number(this.amount);

            if (amount < 10.50) {
                this.errors.push({
                    'field': field,
                    'message': 'The minimum payment amount is £10.50'
                });

                return;
            }

            if (amount > 10000) {
                this.errors.push({
                    'field': field,
                    'message': 'The maximum payment amount is £10,000'
                });

                return;
            }
        }
    }
})